<div class="row profile" *ngIf="data && profile">
    <div class="col-md-8 offset-md-2 col-xs-12 profile--cards">
        <div class="me-col me-col__left col-xs-12">
            <ng-container *ngFor="let card of colData.left; let indexLeft = index;">
                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'contactCard'">
                    <contact-card [profile]="profile" [slug]="card['slug']"></contact-card>
                </div>
                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'personalDataCard'">
                    <personal-information [profile]="profile" [slug]="card['slug']"></personal-information>
                </div>

                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'billingAddressCard'">
                    <billing-card [slug]="card['slug']" [profile]="profile"></billing-card>
                </div>

                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'privacyCard'">
                    <privacy-card [slug]="card['slug']"></privacy-card>
                </div>

                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'myAccountCard'">
                    <my-account-card [profile]="profile" [slug]="card['slug']"></my-account-card>
                </div>

                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'faqProfileCard'">
                    <default-card [profile]="profile" [slug]="card['slug']"></default-card>
                </div>
            </ng-container>
        </div>
        <div class="me-col me-col__right col-xs-12">
            <ng-container *ngFor="let card of colData.right; let indexRight = index;">
                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'contactCard'">
                    <contact-card [profile]="profile" [slug]="card['slug']"></contact-card>
                </div>
                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'personalDataCard'">
                    <personal-information [profile]="profile" [slug]="card['slug']"></personal-information>
                </div>

                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'billingAddressCard'">
                    <billing-card [slug]="card['slug']" [profile]="profile"></billing-card>
                </div>

                <div *ngIf="card['content']['component'] && card['content']['component'] === 'privacyCard'">
                    <default-card [profile]="profile" [icon]="svgIcons.PRIVACY" [slug]="card['slug']" [class]="'bg__secondary'"></default-card>
                </div>

                <div class="" *ngIf="card['content']['component'] && card['content']['component'] === 'myAccountCard'">
                    <my-account-card [profile]="profile" [slug]="card['slug']"></my-account-card>
                </div>

                <div *ngIf="card['content']['component'] && card['content']['component'] === 'faqProfileCard'">
                    <default-card [profile]="profile" [icon]="svgIcons.FAQ" [slug]="card['slug']"></default-card>
                </div>

            </ng-container>
            <button class="btn btn--secondary mb-1" (click)="logout()">
                {{ 'Logout' | translate}}
            </button>
        </div>
    </div>
</div>